import { h } from 'preact'
import Phrase from '../../libs/translationsUtils/phrase'
import CategoryGroup from '../menu/category-group'
import List from '../menu/list'
import Link from '../menu/link'
import Dropdown from '../dropdown/index'
import { CategoryInfo } from './Types'
import Icon from '../assets'

interface Props {
  name: string,
  categories: Array<CategoryInfo>,
  showHome: boolean,
  showRecentlyActive: boolean,
  showUnanswered: boolean,
  showActivitySinceLastVisit: boolean
}

const CategoryMenu = ({ categories, showActivitySinceLastVisit, name, showHome, showRecentlyActive, showUnanswered }: Props) => (
  <div class='main-menu'>
    <Dropdown
      class={'dropdown dropdown--forums-overview'}
      trigger={
        <span style={{ display: 'flex', alignItems: 'center' }} class='main-menu-trigger'>
          <span>{ name }</span>
          <Icon icon='chevronDown' width={16} height={16} />
        </span>
      }
    >
      <span class='arrow is-hidden-S' />

      <List class='main-menu-list--overflow-scroll'>
        {
          (showHome || showRecentlyActive || showActivitySinceLastVisit || showUnanswered) && (
            <List class='main-menu-list--quiclinks'>
              {
                showHome && (
                  <Link href='/'>
                    <Phrase m='Common' p='nav.title.forum.overview' />
                  </Link>
                )
              }

              {
                showRecentlyActive && (
                  <Link
                    href='/search/activity/recent'>
                    <Phrase m='Common' p='nav.title.forum.recent.activity' />
                  </Link>
                )
              }

              {
                showActivitySinceLastVisit && (
                  <Link
                    href='/search/activity/sincelastvisit'>
                    <Phrase m='Common' p='nav.title.forum.activity.last.visit' />
                  </Link>
                )
              }

              {
                showUnanswered && (
                  <Link
                    href='/search/activity/unanswered'>
                    <Phrase m='Common' p='nav.title.forum.unanswered.questions' />
                  </Link>
                )
              }
            </List>
          )
        }

        {categories.length
          ? (
            <section>
              {categories.map(parentCategory => {
                return <CategoryGroup
                  key={parentCategory.id}
                  url={parentCategory.url}
                  title={parentCategory.title}
                  categories={parentCategory.subforums}
                />
              })}

            </section>
          ) : null}
      </List>
    </Dropdown>
  </div>
)

export default CategoryMenu
